import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Footer = () => (
  <footer data-testid="site-footer" style={{ background: "var(--dark)", color: "var(--dark-ink)", paddingTop: 96 }}>
    <div className="container-grav">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-16">
        <div className="lg:col-span-5">
          <img src="/gt-logo.png" alt="Gravitas Technology" style={{ height: 56, width: "auto", filter: "brightness(1.05)" }} />
          <h3 className="font-display" style={{ fontSize: "clamp(28px, 3vw, 40px)", fontWeight: 800, marginTop: 32, lineHeight: 1.1, letterSpacing: "-0.02em", maxWidth: 460 }}>
            Let's turn your data<br />
            <span style={{ color: "var(--green)" }}>into decisions.</span>
          </h3>
          <div style={{ marginTop: 32 }}>
            <Link to="/contact" className="btn btn-light">
              Start a conversation <span className="arrow"><ArrowUpRight size={14} /></span>
            </Link>
          </div>
          <div style={{ marginTop: 40, color: "rgba(246,244,239,0.6)", fontSize: 14, fontFamily: "var(--font-mono)", letterSpacing: "0.06em", textTransform: "uppercase" }}>
            Washington, DC · DMV<br />
            info@gravitastechnology.com
          </div>
        </div>

        <div className="lg:col-span-2">
          <div style={{ fontSize: 11, color: "rgba(246,244,239,0.5)", fontFamily: "var(--font-mono)", letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 600, marginBottom: 20 }}>Capabilities</div>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12 }}>
            {[["/services/devsecops","DevSecOps"],["/services/cloud","Cloud"],["/services/platform","Platform"],["/services/cybersecurity","Cybersecurity"],["/services/aiml","AI/ML"],["/services/pmo","PMO"]].map(([to,l])=>(
              <li key={to}><Link to={to} style={{ color: "rgba(246,244,239,0.85)", textDecoration: "none", fontSize: 15 }}>{l}</Link></li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div style={{ fontSize: 11, color: "rgba(246,244,239,0.5)", fontFamily: "var(--font-mono)", letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 600, marginBottom: 20 }}>Company</div>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12 }}>
            {[["/about","About"],["/government","Government"],["/services","Services"],["/contact","Contact"]].map(([to,l])=>(
              <li key={to}><Link to={to} style={{ color: "rgba(246,244,239,0.85)", textDecoration: "none", fontSize: 15 }}>{l}</Link></li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div style={{ fontSize: 11, color: "rgba(246,244,239,0.5)", fontFamily: "var(--font-mono)", letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 600, marginBottom: 20 }}>Compliance</div>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12 }}>
            {[
              ["https://csrc.nist.gov/publications/detail/sp/800-53/rev-5/final","NIST 800-53"],
              ["https://www.fedramp.gov/","FedRAMP"],
              ["https://dodcio.defense.gov/CMMC/","CMMC 2.0"],
              ["https://dodcio.defense.gov/Portals/0/Documents/Library/(U)ZT_RA_v2.0(U)_Sep22.pdf","DoD Zero Trust"],
            ].map(([to,l])=>(
              <li key={to}><a href={to} target="_blank" rel="noopener noreferrer" style={{ color: "rgba(246,244,239,0.85)", textDecoration: "none", fontSize: 15 }}>{l} ↗</a></li>
            ))}
          </ul>
        </div>
      </div>

      <div style={{ borderTop: "1px solid rgba(246,244,239,0.1)", padding: "28px 0", display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
        <div style={{ color: "rgba(246,244,239,0.5)", fontSize: 13, fontFamily: "var(--font-mono)", letterSpacing: "0.06em" }}>
          © {new Date().getFullYear()} Gravitas Technology Solutions. All rights reserved.
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {["NIST 800-53","FEDRAMP","CMMC 2.0","ZERO TRUST"].map((b)=>(
            <span key={b} style={{ fontSize: 10, letterSpacing: "0.15em", padding: "6px 12px", border: "1px solid rgba(246,244,239,0.2)", borderRadius: 100, color: "rgba(246,244,239,0.7)", fontFamily: "var(--font-mono)", fontWeight: 600 }}>{b}</span>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
